import { render, staticRenderFns } from "./SimpleFileArea.vue?vue&type=template&id=a9168486&scoped=true&"
import script from "./SimpleFileArea.vue?vue&type=script&lang=js&"
export * from "./SimpleFileArea.vue?vue&type=script&lang=js&"
import style0 from "./SimpleFileArea.vue?vue&type=style&index=0&id=a9168486&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9168486",
  null
  
)

export default component.exports